import { Copy } from "lucide-react";
import { toast } from "sonner";
import { SECTIONS, parseSections, cleanPrompt, buildFullText } from "@/lib/sections";
import { SectionBody } from "@/components/SectionBody";
import { PromptEditor } from "@/components/PromptEditor";
import { ToolPrompts } from "@/components/ToolPrompts";

export const AnalysisView = ({ analysis, streaming, onPromptSaved }) => {
  const { sections, current } = parseSections(analysis.content || "");
  const prompt = streaming ? cleanPrompt(sections[6] || "") : analysis.prompt || cleanPrompt(sections[6] || "");

  const copyAll = async () => {
    await navigator.clipboard.writeText(buildFullText(sections, prompt));
    toast.success("Analisi completa copiata");
  };

  return (
    <div data-testid="analysis-results-container">
      <div className="flex flex-wrap items-center gap-4 pb-6 border-b border-[var(--rf-ink)]">
        <h2 className="text-lg font-bold tracking-tight">Reverse editing</h2>
        <span className="rf-mono text-[10px] tracking-[0.25em] uppercase text-[var(--rf-grey)]" data-testid="analysis-streaming-status">
          {streaming ? <span className="rf-red">● Analisi in corso — sezione {String(current || 1).padStart(2, "0")}/06</span> : "Completata"}
        </span>
        {!streaming && (
          <button onClick={copyAll} className="ml-auto rf-btn rf-btn-ghost rf-btn-sm" data-testid="copy-full-analysis-button">
            <Copy size={13} /> Copia tutto
          </button>
        )}
      </div>
      {SECTIONS.map((s) => {
        const body = sections[s.n];
        const active = streaming && current === s.n;
        if (body === undefined && streaming && s.n > (current || 1)) return null;
        return (
          <section key={s.n} className="grid grid-cols-12 gap-4 py-8 border-b rf-line rf-fade" data-testid={`analysis-section-${s.n}-${s.slug}`}>
            <div className="col-span-12 sm:col-span-3">
              <span className={`block text-5xl font-black tracking-tighter leading-none ${active || s.n === 6 ? "rf-red" : ""}`}>
                {String(s.n).padStart(2, "0")}
              </span>
              <h3 className="mt-3 font-bold leading-tight">{s.it}</h3>
              <p className="rf-mono text-[10px] tracking-[0.15em] uppercase text-[var(--rf-grey)] mt-1">{s.en}</p>
            </div>
            <div className="col-span-12 sm:col-span-9">
              {s.n === 6 ? (
                body !== undefined || !streaming ? (
                  <PromptEditor analysisId={analysis.id} prompt={prompt} streaming={streaming} onSaved={onPromptSaved} />
                ) : null
              ) : body ? (
                <div className={active ? "rf-caret" : ""}><SectionBody text={body} /></div>
              ) : (
                <span className="text-sm text-[var(--rf-grey)]">{streaming ? "In attesa…" : "—"}</span>
              )}
            </div>
          </section>
        );
      })}
      {!streaming && <ToolPrompts analysisId={analysis.id} saved={analysis.variants} />}
    </div>
  );
};
